import { render, staticRenderFns } from "./EditAutoDeliveryCancelReasonsModal.vue?vue&type=template&id=161c4cbc&scoped=true&lang=pug&"
import script from "./EditAutoDeliveryCancelReasonsModal.vue?vue&type=script&lang=js&"
export * from "./EditAutoDeliveryCancelReasonsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAutoDeliveryCancelReasonsModal.vue?vue&type=style&index=0&id=161c4cbc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c4cbc",
  null
  
)

export default component.exports